import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="bg-[var(--rts-blue-pale)] py-32" data-testid="not-found">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="font-display text-7xl text-[var(--rts-red)] mb-4">404</p>
        <h1 className="font-display text-4xl text-[var(--rts-ink)] mb-3">Page not found</h1>
        <p className="text-[var(--rts-ink-soft)] mb-8">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="inline-flex items-center gap-2 bg-[var(--rts-blue-deep)] text-white px-6 py-3 rounded-full font-bold hover:bg-[var(--rts-blue)] transition" data-testid="not-found-home-link">
          Back to Home
        </Link>
      </div>
    </section>
  );
}
